// import React from 'react'
// import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {}

export const messages = {
  profileTitleText: { id: 't.app.accessibility.header.profile.label.ariaLabel', defaultMessage: 'Profile' },
  mobileNavAltText: { id: 't.app.accessibility.header.mobileNav.alt.ariaLabel', defaultMessage: 'Navigation menu' }
}

export default formattedMessage
